import { render, staticRenderFns } from "./textSmall.vue?vue&type=template&id=2002ac3f"
import script from "./textSmall.vue?vue&type=script&lang=js"
export * from "./textSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports